import { ProjectTrashItemGridView } from './ProjectTrashItemGridView'
import { ProjectTrashItemListView } from './ProjectTrashItemListView'

export const ProjectTrashItem = {
  Card: ProjectTrashItemGridView,
  ListItem: ProjectTrashItemListView,
}
